import themesConfig from 'app/configs/themesConfig';

const settingsConfig = {
  layout: {
    style: 'layout1', // layout1 layout2 layout3
    config: {}, // checkout default layout configs at app/theme-layouts for example  app/theme-layouts/layout1/Layout1Config.js
  },
  customScrollbars: true,
  direction: 'ltr', // rtl, ltr
  theme: {
    main: themesConfig.default,
    navbar: themesConfig.defaultDark,
    toolbar: themesConfig.default,
    footer: themesConfig.defaultDark,
    orderTimeLine: themesConfig.defaultOrderTimeLine,
  },
  /*
   To make whole app auth protected by default set defaultAuth:['admin','staff','user']
   To make whole app accessible without authorization by default set defaultAuth: null
   *** The individual route configs which has auth option won't be overridden.
   */
  /* This is a hack right now for possiblity to view default page */
  defaultAuth: [
    'Super Admin',
    'Admin',
    'Sales',
    'Assistant',
    'Opener',
    'Closer',
    'Processor',
    'Researcher',
    'Outside Sales',
    'Referral Partner',
    'Company Owner',
    'Account Manager',
    'Referral Office',
  ],
  /*
    Default redirect url for the logged-in user,
   */
  loginRedirectUrl: '/clients',
  logoUrl: 'assets/images/logo/logo-white-text.png',
};

export default settingsConfig;
